import { Component } from "react";
import { AlertTriangle } from "lucide-react";

/**
 * Catches render errors in the routed subtree so a single component crash
 * doesn't blank the whole app. React error boundaries must be class
 * components (there is no hook equivalent).
 */
export default class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // eslint-disable-next-line no-console
        console.error("Unhandled render error:", error, errorInfo);
    }

    handleReload = () => {
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-screen bg-[#09090B] flex items-center justify-center p-4">
                    <div className="max-w-md w-full text-center space-y-4">
                        <div className="mx-auto w-12 h-12 rounded-full bg-red-500/15 flex items-center justify-center">
                            <AlertTriangle className="text-red-400" size={24} />
                        </div>
                        <h1 className="text-lg font-heading font-semibold text-zinc-100">Something went wrong</h1>
                        <p className="text-sm text-zinc-500">
                            An unexpected error occurred while rendering this page. Reloading usually fixes it.
                        </p>
                        <button
                            onClick={this.handleReload}
                            className="inline-flex items-center justify-center rounded-md bg-green-600 hover:bg-green-700 text-white text-sm font-medium px-4 py-2 transition-colors"
                        >
                            Reload
                        </button>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}
